import { render, staticRenderFns } from "./ItemWidgetSwipe.vue?vue&type=template&id=12bf6aae&scoped=true&"
import script from "./ItemWidgetSwipe.vue?vue&type=script&lang=js&"
export * from "./ItemWidgetSwipe.vue?vue&type=script&lang=js&"
import style0 from "./ItemWidgetSwipe.vue?vue&type=style&index=0&id=12bf6aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf6aae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Touch})
